import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Modal from 'react-awesome-modal';

import { handleShowVerifiedProfileStepsModal } from '../actions/commission-scheme-actions';
import commissionSchemeConstants from '../constants/commission-scheme-constants';
import constants from '../../../../common/constants';

import '../styles/verified-profile-steps-modal.css';

class VerifiedProfileStepsModal extends Component {
  closeModal = () => {
    const { handleShowVerifiedProfileStepsModal } = this.props;

    handleShowVerifiedProfileStepsModal(false);
  };

  getPhotoUrl(userId, appendTimestamp = false) {
    const imgUrl = `${constants.profile_photo_base_url}${userId}.jpg${appendTimestamp ? `?${new Date().getTime()}` : ''}`;

    return imgUrl;
  }

  renderStepsToComplete = () => {
    const { t } = this.context;

    return (
      <div className="verify-profile-modal__steps">
        <div className="verify-profile-modal__steps__title">{t('GET_VERIFIED_MODAL.STEPS')}</div>
        {commissionSchemeConstants.get_verified_goals.map(goal => {
          return (
            <div key={goal} className="verify-profile-modal__steps__item">
              <div className="verify-profile-modal__steps__item__point" />
              <span>{t(goal)}</span>
            </div>
          );
        })}
      </div>
    );
  };

  render = () => {
    const { t } = this.context;
    const { showVerifiedProfileStepsModal, profile } = this.props;

    return (
      <Modal visible={showVerifiedProfileStepsModal} effect="fadeInUp" onClickAway={() => this.closeModal()} width="560">
        <div className="verify-profile-modal">
          <div className="modal-header">
            <div className="verify-profile-modal__image">
              <div className="verify-profile-modal__image__item" style={{ backgroundImage: `url(${this.getPhotoUrl(profile.user_id)}),  url(${constants.avatar_photo_default_url})` }} />
              <i className="icn icn-circle-check" />
            </div>
          </div>
          <div className="modal-body">
            <div className="verify-profile-modal__title">{t('GET_VERIFIED_MODAL.TITLE')}</div>
            <div className="verify-profile-modal__description">{t('GET_VERIFIED_MODAL.INFORMATION')}</div>
            {this.renderStepsToComplete()}
          </div>
        </div>
      </Modal>
    );
  };
}

VerifiedProfileStepsModal.contextTypes = {
  t: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  showVerifiedProfileStepsModal: state.commissionSchemeReducer.showVerifiedProfileStepsModal,
  profile: state.userProfileReducer.profile,
});

const mapDispatchToProps = dispatch => ({
  handleShowVerifiedProfileStepsModal: data => {
    dispatch(handleShowVerifiedProfileStepsModal(data));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(VerifiedProfileStepsModal);



// WEBPACK FOOTER //
// ./src/app/main/commission-scheme/components/verified-profile-steps-modal.js